import { Component, effect, input, model, output, signal } from '@angular/core';
import { UserRoleRepresentationDto, UserRolesRepresentationDto } from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { UserRolesDisplayAdminCoreComponent } from '../display/roles-display.component';
import { UserRolesFormAdminCoreComponent } from '../form/roles-form.component';

@Component({
  selector: 'core-user-roles-edit',
  imports: [AuraEditWrapperComponent, UserRolesDisplayAdminCoreComponent, UserRolesFormAdminCoreComponent],
  templateUrl: './roles-edit.component.html',
})
export class UserRolesEditAdminCoreComponent {
  initialRoles = input.required<UserRoleRepresentationDto[]>();
  isEditing = model<boolean>(false);
  closeEditing = input<boolean>(false);
  saved = output<UserRolesRepresentationDto>();

  currentRoles = signal<UserRoleRepresentationDto[]>([]);

  constructor() {
    effect(() => {
      const roles = this.initialRoles();
      if (roles) {
        this.currentRoles.set(roles);
      }
    });

    effect(() => {
      if (this.closeEditing()) {
        this.isEditing.set(false);
      }
    });
  }

  onSave(roles: UserRoleRepresentationDto[]): void {
    this.saved.emit({ roles });
  }
}
